import { Directive, Input, Output, EventEmitter, ElementRef, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import * as _ from 'lodash';

import { DragAndDropService, DragAction } from './drag-and-drop.service';

import { Draggable } from './classes/draggable';

@Directive({
  selector: '[uexDraggable]',
  host: {
    'class': 'uex-draggable',
    '[attr.draggable]': 'enabled ? true : null',
    '[class.dragging]': 'dragging'
  }
})
export class DraggableDirective implements OnInit, OnDestroy {
  @Input('uexDraggable') private set _setEnabled(enabled: boolean | string) {
    let name = null;

    if (_.isString(enabled)) {
      this.enabled = true;
      name = _.isEmpty(enabled) ? null : (<string>enabled);
    } else {
      this.enabled = !!enabled;
      name = null;
    }

    this.draggable.setEnabled(this.enabled);
    this.draggable.setName(name);
  }

  @Input('dragAction') private set _setDragAction(action: DragAction) {
    this.draggable.setAction(action);
  }

  @Input('dragWithPlaceholder') private set _setUsePplaceholder(use_placeholder: boolean) {
    this.draggable.setUsePlaceholder(use_placeholder);
  }

  @Input('dragPlaceholderClass') private set _setPlaceholderClass(placeholder_class: string) {
    this.draggable.setPlaceholderClass(placeholder_class);
  }

  @Input('dragData') private set _setDragData(data: any) {
    this.draggable.setData(data);
  }

  @Output('onDragStart') public onDragStart: EventEmitter<DragEvent> = new EventEmitter();
  @Output('onDragEnd') public onDragEnd: EventEmitter<DragEvent> = new EventEmitter();

  constructor(
    private _service: DragAndDropService,
    public elementRef: ElementRef
  ) {
    this.draggable = this._service.registerDraggable({
      element: this._element
    });
  }

  public enabled = true;
  public dragging = false;

  public draggable: Draggable;
  private _drag_start_subscription: Subscription;
  private _drag_end_subscription: Subscription;

  public ngOnInit() {
    this._drag_start_subscription = this.draggable.onStart.subscribe((event: DragEvent) => {
      this.dragging = true;
      this.onDragStart.emit(event);
    });

    this._drag_end_subscription = this.draggable.onEnd.subscribe((event: DragEvent) => {
      this.dragging = false;
      this.onDragEnd.emit(event);
    });
  }

  public ngOnDestroy() {
    if (this._drag_start_subscription) { this._drag_start_subscription.unsubscribe(); }
    if (this._drag_end_subscription) { this._drag_end_subscription.unsubscribe(); }

    this._service.unregisterDraggable(this.draggable);
  }

  private get _element (): HTMLElement {
    return this.elementRef.nativeElement;
  }
}
